/* eslint-disable import/prefer-default-export */
import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import MockAdapter from 'axios-mock-adapter'
import Cookies from 'js-cookie'
import AxiosInterceptor from '../hooks/AxiosInterceptorHook'
import {apiURLs, AddPDPCookie, } from './Utility'

import { getCsrfToken as getStoredCsrfToken } from './csrfToken'

const csrfCookieNames = ['XSRF-TOKEN', 'CSRF-TOKEN', 'X-CSRF-TOKEN']

const getCsrfToken = () => {
  const storedToken = getStoredCsrfToken()
  if(storedToken) {
    return storedToken
  }
  for(let i = 0; i < csrfCookieNames.length; i += 1) {
    const token = Cookies.get(csrfCookieNames[i])
    if(token) {
      return token
    }
  }
  return null
}

const withCsrfHeader = (request = {}) => {
  const method = (request.method || 'GET').toUpperCase()
  if(!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return request
  }

  const csrfToken = getCsrfToken()
  if(!csrfToken) {
    return Promise.reject(new Error('CSRF token not found. Unable to send request.'))
  }

  return {
    ...request,
    headers: {
      ...(request.headers || {}),
      'X-CSRF-Token': csrfToken,
      'X-XSRF-TOKEN': csrfToken
    }
  }
}

/**
 * Custome axios instance for usermanager api
 * @param {string} companyId
 * @param {string} iPlanetDirectoryProCookie
 * @param {string} bearerToken
 */
// defaults for bearer token and planetprocookie are set in loginHook
// after call to logLogin
const createAtmAccessMgmtAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: `${apiURLs.atmAccessMgmtBaseUrl}`,
    headers: {
      'Content-Type': 'application/json'
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: true

  })

  AddPDPCookie(axiosInstance)
  axiosInstance.interceptors.request.use(withCsrfHeader)

  const interceptor = AxiosInterceptor(axiosInstance)

  return {axiosInstance, interceptor}
}

const AtmAccessMgmtAxiosInstance  = createAtmAccessMgmtAxiosInstance()



export default {

  getAtmAccessMgmtCredential: (CompanyID,RoleID,accessMgmtFormData) => {

      // eslint-disable-next-line no-underscore-dangle
      if (window._env.WORKSTATION_LIST) {

        // This sets the mock adapter on the default instance
        const mock = new MockAdapter(axios);

        // Mock any GET request to /users
        // arguments for reply are (status, data, headers)
        mock.onGet("/").reply(200,
          // eslint-disable-next-line no-underscore-dangle
          window._env.WORKSTATION_LIST
        );

        return axios.get("/")
      }

      const url = `/companies/${CompanyID}/roles/${RoleID}/passwords`
      return AtmAccessMgmtAxiosInstance.axiosInstance({
        url,
        method: 'POST',
      data:
        {...accessMgmtFormData}
      })
    },

  setJwtToken: jwtToken => {
    AtmAccessMgmtAxiosInstance.axiosInstance.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
  },

  setRequestInterceptor: (interceptor) => {
    AtmAccessMgmtAxiosInstance.interceptor.setRequestInterceptor(interceptor)
  },
  setResponseInterceptor: (interceptor) => {
    AtmAccessMgmtAxiosInstance.interceptor.setResponseInterceptor(interceptor)
  },

  ready: () => {
    return (AtmAccessMgmtAxiosInstance.axiosInstance
      && AtmAccessMgmtAxiosInstance.axiosInstance.defaults
      && AtmAccessMgmtAxiosInstance.axiosInstance.defaults.headers
      && AtmAccessMgmtAxiosInstance.axiosInstance.defaults.headers.common
      && AtmAccessMgmtAxiosInstance.axiosInstance.defaults.headers.common.Authorization
      && true)
  },

}

